var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.629 3v1.048a6.372 6.372 0 0 1 5.54 3.965l.968-.4A7.42 7.42 0 0 0 13.629 3ZM13.629 17.814v-1.049a6.372 6.372 0 0 0 5.537-3.958l.968.402a7.42 7.42 0 0 1-6.505 4.605ZM7.484 15.052c.125.155.256.305.393.45l.045-.039-.438-.411ZM8.992 16.468l-.276-.26a.434.434 0 0 1-.027.034c.099.078.2.153.303.226Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m7.922 15.463-.045.039-4.725 4.075a.436.436 0 0 0-.024.64l.656.655c.175.175.46.17.629-.012l4.271-4.613.005-.005a.434.434 0 0 0 .027-.033l-.794-.746Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m8.673 15.642-.157-.157a.436.436 0 0 0-.594-.022l.794.746a.436.436 0 0 0-.043-.567Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.85 10.407c0 1.758.612 3.374 1.634 4.645l.438.411a.436.436 0 0 1 .594.022l.157.157c.153.154.169.395.043.567l.276.259a7.375 7.375 0 0 0 3.605 1.325V16.74a6.37 6.37 0 0 1 0-12.668V3.02A7.42 7.42 0 0 0 6.59 7.173c-.482 1-.74 2.104-.74 3.234Z",
    fill: "#fff"
  })));
};
export default SvgSearch;